import ApprovedVideosQuery from '@/graphql/video/ApprovedVideosQuery.gql'
import UnreviewedVideosQuery from '@/graphql/video/UnreviewedVideosQuery.gql'
import VideosQuery from '@/graphql/video/VideosQuery.gql'
import TemplateVideosQuery from '@/graphql/video/TemplateVideosQuery.gql'
import PaginateVideoQuery from '@/graphql/video/PaginateVideoQuery.gql'
import PaginationTemplateVideoQuery from '@/graphql/video/PaginationTemplateVideoQuery.gql'

import apollo from '@/graphql'

// initial state
const state = {
  approvedVideos: [],
  isVideosLoading: false,
  templateVideos: [],
  unreviewedVideos: [],
  loadingUnreviewedVideos: false,
  totalUnreviewedVideos: 0,
  videos: [],
  listVideoWithPagination: [],
  paginations: {},
  loadingFetchVideo: false,
}

// getters
const getters = {
  approvedVideos: st => st.approvedVideos,
  isVideosLoading: st => st.isVideosLoading,
  templateVideos: st => st.templateVideos,
  unreviewedVideos: st => st.unreviewedVideos,
  loadingUnreviewedVideos: st => st.loadingUnreviewedVideos,
  totalUnreviewedVideos: st => st.totalUnreviewedVideos,
  videos: st => st.videos,
  listVideoWithPagination: st => st.listVideoWithPagination,
  paginations: st => st.paginations,
  getFetchVideoLoading: st => st.loadingFetchVideo,
}

// mutations
const mutations = {
  setApprovedVideos(st, approvedVideos) {
    state.approvedVideos = approvedVideos
  },

  setUnreviewedVideos(st, unreviewedVideos) {
    state.unreviewedVideos = unreviewedVideos
  },

  setTotalUnreviewedVideos(st, totalUnreviewedVideos) {
    state.totalUnreviewedVideos = totalUnreviewedVideos
  },

  setLoadingUnreviewedVideos(st, loadingUnreviewedVideos) {
    state.loadingUnreviewedVideos = loadingUnreviewedVideos
  },

  setTemplateVideos(st, templateVideos) {
    state.templateVideos = templateVideos
  },

  setVideos(st, videos) {
    state.videos = videos
  },

  setVideosLoadingState(st, value) {
    state.isVideosLoading = value
  },

  setListVideoWithPagination(state, videos) {
    state.listVideoWithPagination = videos
  },
  setpaginationon(state, paginations) {
    state.paginations = paginations
  },
  setLoadingFetchVideo(state, value) {
    state.loadingFetchVideo = value
  },
}

// actions
const actions = {
  loadApprovedVideos({ commit }) {
    apollo.defaultClient.watchQuery({
      fetchPolicy: 'network-only',
      query: ApprovedVideosQuery,
    }).subscribe(({ data: { approvedVideos } }) => {
      commit('setApprovedVideos', approvedVideos)
    })
  },

  loadUnreviewedVideos({ commit }, payload) {
    const { totalOnly, ...rest } = payload
    commit('setLoadingUnreviewedVideos', true)
    apollo.defaultClient.watchQuery({
      fetchPolicy: 'network-only',
      query: UnreviewedVideosQuery,
      variables: rest,
    }).subscribe(({ data: { unreviewedVideos } }) => {
      if (!totalOnly) {
        commit('setUnreviewedVideos', unreviewedVideos.list)
      }
      commit('setTotalUnreviewedVideos', unreviewedVideos.filter.total)
      commit('setLoadingUnreviewedVideos', false)
    })
  },

  loadVideos({ commit }) {
    commit('setVideosLoadingState', true)
    apollo.defaultClient.watchQuery({
      fetchPolicy: 'network-only',
      query: VideosQuery,
    }).subscribe(({ data: { videos } }) => {
      commit('setVideos', videos)
      commit('setVideosLoadingState', false)
    })
  },

  loadTemplateVideos({ commit }) {
    commit('setVideosLoadingState', true)
    apollo.defaultClient.watchQuery({
      fetchPolicy: 'network-only',
      query: TemplateVideosQuery,
    }).subscribe(({ data: { templateVideos } }) => {
      commit('setTemplateVideos', templateVideos)
      commit('setVideosLoadingState', false)
    })
  },

  fetchPaginateVideo({ commit }, { pagination, tab, aspectRatio }) {
    if (tab === 'library') {
      commit('setLoadingFetchVideo', true)

      const {
        page,
        pageSize,
        search,
      } = { ...pagination }

      apollo.defaultClient.watchQuery({
        fetchPolicy: 'network-only',
        query: PaginateVideoQuery,
        variables: { page, pageSize, search, aspectRatio },
      }).subscribe(({ data: { paginateVideos } }) => {
        commit('setListVideoWithPagination', paginateVideos.videos)
        commit('setpaginationon', paginateVideos.pagination)
        commit('setLoadingFetchVideo', false)
      })
    } else if (tab === 'templates') {
      commit('setLoadingFetchVideo', true)

      apollo.defaultClient.watchQuery({
        fetchPolicy: 'network-only',
        query: PaginationTemplateVideoQuery,
        variables: pagination,
      }).subscribe(({ data }) => {
        commit('setListVideoWithPagination', data.paginateTemplateVideos.videos)
        commit('setpaginationon', data.paginateTemplateVideos.pagination)
        commit('setLoadingFetchVideo', false)
      })
    }
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/video/VideoList.js